<template>
	<div class="wrapper news-page">
		<!-- Header -->
		<Header />
		<!-- HeaderMenu -->
		<HeaderMenu />

		<div class="contents">
			<div class="layout">
				<div class="left">
					<div class="pc-only">
						<Sidebar />
					</div>
				</div>
				<div class="right">
					<h1>タイトルタイトルタイトル</h1>
					<div class="news-box">
						<div class="date">2022.01.10</div>
						<p>
							テキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキスト<br />
							テキストテキストテキストテキストテキストテキストテキストテキスト
						</p>
						<p>
							テキストテキストテキストテキスト<br />
							テキストテキストテキストテキストテキストテキストテ<br />
							キストテキス<br />
							トテキストテキストテキストテキスト
						</p>
					</div>
					<div class="btn">
						<router-link to="/newslist" class="link-over">{{
							$t("To the information list")
						}}</router-link>
					</div>
				</div>
			</div>
		</div>
		<!-- /.contents -->

		<Footer title="NewsList" />
	</div>
</template>
<style scoped></style>
<script>
import Header from "@/components/Header.vue";
import HeaderMenu from "@/components/HeaderMenu.vue";
import Sidebar from "@/components/Sidebar.vue";
import Footer from "@/components/Footer.vue";
export default {
	name: "Authentication",
	components: {
		Header,
		HeaderMenu,
		Sidebar,
		Footer,
	},
	data: () => {
		return {
			title: "NewsList",
			NEWS_ITEM: [
				{
					id: 1,
					date: "2022.01.10",
					newsFlag: true,
					title: "タイトルタイトル",
					link: "/news",
					description:
						"テキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキスト",
				},
			],
		};
	},
	methods: {},
	computed: {},
	mounted: function () {},
};
</script>
